import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";
import _ from "lodash";

let redux = reduxCreator.type('FORUM_TOPIC').plugin(axiosPlugin);

let fetchForumTopicAction = redux.fetchActionGetOne();

let createForumTopicAction = redux.fetchActionCreate();

let updateForumTopicAction = redux.fetchActionUpdate();

let deleteForumTopicAction = redux.fetchActionDelete();

redux.reducerForType('UPDATE_FOLLOW', (state,payload) => {
    let newState = {...state};

    if(_.get(payload, 'data.topicId') && _.get(newState, 'data._id')){
        if(newState.data._id.toString()  === payload.data.topicId.toString()){
            newState = {
                ...newState,
                data : {
                    ...newState.data,
                    isFollow : payload.data.isFollow
                }
            }
        }
    }
    return newState;
});

export const TYPES = redux.types;

export const fetchForumTopic = (topicId, query = {}) => fetchForumTopicAction(`/topics/${topicId}?${queryString.stringify(query)}`);
export const createForumTopic = (forumId, data = {}) => createForumTopicAction(`/forums/${forumId}/topics`, data);
export const updateForumTopic = (forumId, topicId, data = {}) => updateForumTopicAction(`/forums/${forumId}/topics/${topicId}`, data);
export const moveForumTopic = (forumId, topicId, data = {}) => updateForumTopicAction(`/forums/${forumId}/topics/${topicId}/move`, data);
export const deleteForumTopic = (forumId, topicId = {}) => deleteForumTopicAction(`/forums/${forumId}/topics/${topicId}`);
export const resetForumTopic = () => redux.actions.reset();

export const forumTopic = redux.reducer();